import { render, staticRenderFns } from "./jxtxContent.vue?vue&type=template&id=53fb705b&scoped=true"
import script from "./jxtxContent.vue?vue&type=script&lang=ts"
export * from "./jxtxContent.vue?vue&type=script&lang=ts"
import style0 from "./jxtxContent.vue?vue&type=style&index=0&id=53fb705b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb705b",
  null
  
)

export default component.exports